export default {
  baseUrl: 'https://sp.api.v2.hyperthings.in/api/v1/',
};
